import * as mongoose from 'mongoose';
import { modelOptions, prop } from '@typegoose/typegoose';
import { TimeRange } from './time.model';
import { DashboardType, WidgetType } from '@nirvana/shared/dtos/types/dashboards/common';

export class Position {
  @prop({ required: true })
  x: number;

  @prop({ required: true })
  y: number;
}

export class Widget {
  @prop({ required: true, enum: WidgetType, type: mongoose.Schema.Types.Number })
  type: WidgetType;

  // On the frontend, gridstack will know to align widgets based on width & height,
  // so coordinates are not needed. These will be set only for dashboards with custom
  // widgets, which can be dragged and dropped.
  @prop({ required: false })
  pos?: Position;

  @prop({ required: true })
  width: number;

  @prop({ required: true })
  height: number;
}

export class Dashboard {
  @prop({ required: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true })
  name: string;

  @prop({ required: true, enum: DashboardType, type: mongoose.Schema.Types.Number })
  type: DashboardType;

  @prop({ required: false, _id: false, type: TimeRange })
  timeRange?: TimeRange;

  @prop({
    required: false,
    type: Widget,
    // If we have no widgets, we should not create the field as an empty array,
    // which is the default behaviour with mongoose
    default: undefined,
    // Subdocuments should get their own id
    _id: true,
  })
  widgets?: Array<Widget>;

  @prop({ required: true, type: String })
  targets: Array<string>;
}

@modelOptions({ schemaOptions: { collection: 'dashboards', timestamps: true }, options: { customName: 'dashboards' } })
export class DashboardsConfig {
  @prop({
    required: true,
    index: true,
    // One config per user
    unique: true,
  })
  userId: mongoose.Types.ObjectId;

  @prop({
    required: true,
    index: true,
  })
  companyId: mongoose.Types.ObjectId;

  @prop({
    required: true,
    type: Dashboard,
    // Subdocuments should get their own id
    _id: true,
  })
  dashboards: Array<Dashboard>;
}
